// extracted by mini-css-extract-plugin
module.exports = {"container":"manaCurveV2_container__xmuGC","avgCmc":"manaCurveV2_avgCmc__8_ROf","totalMv":"manaCurveV2_totalMv__Ee9OA","emptyChart":"manaCurveV2_emptyChart__ld67h"};